import { MatchAccessibility } from '@okletsplay/core/src/modules/match/enums';
import { MATCH_PLAYERS_DEFAULT_SETTINGS } from 'modules/matches/constants';
import { MatchFormFields } from 'modules/matches/interfaces/forms';
import { UserBalanceValidationOptions } from 'modules/payments/validators';
import { array, mixed, number, object, string, boolean } from 'yup';

export type CreateMatchValidationOptions = UserBalanceValidationOptions;

export const getCreateMatchValidationSchema = (options: CreateMatchValidationOptions) => {
  return object().shape({
    gameId: string().required().label('Game Identifier'),
    accessibility: mixed()
      .required()
      .oneOf(Object.values(MatchAccessibility))
      .label('Accessibility'),
    isJoinApproveRequired: boolean(),
    entryFee: number().min(0).required().userBalance(options).label('Entry Fee'),
    players: array()
      .required()
      .label('Players')
      .test({
        name: 'players',
        test: function (players: string[] | undefined) {
          const parent = this.parent as MatchFormFields;
          const playersSettings = parent.playersSettings ?? MATCH_PLAYERS_DEFAULT_SETTINGS;

          if (playersSettings.minPlayersCount > playersSettings.maxPlayersCount) {
            throw this.createError({
              message: 'Min players count should be less than max players count',
            });
          }

          if ((players?.length ?? 1) > playersSettings.maxPlayersCount - 1) {
            throw this.createError({
              message: 'Players count should not be more than max',
            });
          }

          if (parent.accessibility !== MatchAccessibility.Private) {
            return true;
          }

          if (playersSettings.minPlayersCount !== playersSettings.maxPlayersCount) {
            throw this.createError({
              message: 'Min players count should be equal to max for private match',
            });
          }

          if (players?.length !== playersSettings.minPlayersCount - 1) {
            throw this.createError({
              message: 'Invite min players count for private match',
            });
          }

          return true;
        },
      }),
  });
};

export const lichessMatchTimeValidationSchema = object().shape({
  clockLimit: number().min(0).max(10800),
  clockIncrement: number().min(0).max(60),
});

export const lidraughtsMatchTimeValidationSchema = object().shape({
  clockLimit: number().min(0).max(10800),
  clockIncrement: number().min(0).max(180),
});
